
export enum EventPublishType {
    Undefined = 0,
    All = 1,
    Invitees = 2
}
